/* ==========================================================================
   UiPanelVehicleFerry > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const UiPanelClient = require('@bluekiri/alexandria-contrib-components/components/ui-panel/client/js');
const PanelVehicleClient = require('@bluekiri/alexandria-contrib-components/components/panel-vehicle/client/js');
const PanelPetClient = require('@bluekiri/alexandria-contrib-components/components/panel-pet/client/js');

/**
 * UiPanelVehicleFerry component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function UiPanelVehicleFerry(selector = '[data-component="UiPanel"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Instance reference */
        const instance = {};

        /* Vehicle reference */
        instance.vehicle = PanelVehicleClient(`${selector} [data-component="PanelVehicle"]`, {
            ...configuration.vehicle
        });

        /* Pet reference */
        instance.pet = PanelPetClient(`${selector} [data-component="PanelPet"]`, {
            ...configuration.pet
        });

        /* Panel reference */
        instance.uipanel = UiPanelClient(`${selector}`, {
            ...configuration.panel
        });

        return instance;
    }
};
